<template>
    <section>
        <Hero/>
        <PageContent/>
    </section>
</template>

<script setup>
import Hero from "@/views/LatestNewsComponents/Hero";
import PageContent from "@/views/LatestNewsComponents/PageContent";
</script>
